import {alertColour, notificationColour, subduedTextColour, warningColour} from "../../../style/styleConsts";
import todayImage from "../../../../images/icon-calendar-red@2x.png";
import tomorrowImage from "../../../../images/icon-calendar-orange@2x.png";
import inTwoDaysImage from "../../../../images/icon-calendar-yellow@2x.png";
import previousDayImage from "../../../../images/icon-calendar-grey@2x.png";
import {ChronoUnit, Clock, ZonedDateTime, ZoneId} from "js-joda";

const ignoreRawTimes = new Set(["Unspecified", ""])

export function getEarningsTime(earnings) {
    return ignoreRawTimes.has(earnings.rawTime) ? "" : ` (${earnings.rawTime})`;
}

export const contentMapping = {
    "0": {text: "Today", colour: alertColour, image: todayImage, sortValue: 0},
    "1": {text: "Tomorrow", colour: warningColour, image: tomorrowImage, sortValue: 1},
    "2": {text: "In 2 days", colour: notificationColour, image: inTwoDaysImage, sortValue: 2},
    "3": {text: "In 3 days", colour: notificationColour, image: inTwoDaysImage, sortValue: 3},
    "-1": {text: "Yesterday", colour: subduedTextColour, image: previousDayImage, sortValue: 4},
    "-2": {text: "2 days ago", colour: subduedTextColour, image: previousDayImage, sortValue: 5}
};

export function getProximityDaysAwayFromPairOfEarnings(earnings, clock = Clock.systemDefaultZone()) {
    const nextEarnings = earnings.nextEarnings ? getProximityDaysFromToday(earnings.nextEarnings, clock) : null;
    const previousEarnings = earnings.previousEarnings ? getProximityDaysFromToday(earnings.previousEarnings, clock) : null;
    return nextEarnings !== null ? nextEarnings : previousEarnings !== null ? previousEarnings : null;
}

export function setEarningsSortPriorityValues(earnings, clock = Clock.systemDefaultZone()) {
    const nextEarningsProximity = earnings.nextEarnings ? getProximityDaysFromToday(earnings.nextEarnings, clock) : null;
    const previousEarningsProximity = earnings.previousEarnings ? getProximityDaysFromToday(earnings.previousEarnings, clock) : null;
    return nextEarningsProximity !== null ? contentMapping[nextEarningsProximity.daysFromToday].sortValue :
           previousEarningsProximity !== null ? contentMapping[previousEarningsProximity.daysFromToday].sortValue :
           null;
}

const zonedDateToLocalDate = (earningsDate) => ( ZonedDateTime.parse(earningsDate).withZoneSameInstant(ZoneId.systemDefault()).toLocalDate() );

export function getProximityDaysFromToday(earningsDateObject, clock = Clock.systemDefaultZone()) {
    const today = ZonedDateTime.now(clock);
    const daysFromToday = earningsDateObject.instant ? today.toLocalDate().until(zonedDateToLocalDate(earningsDateObject.instant), ChronoUnit.DAYS) : null;
    return contentMapping.hasOwnProperty(daysFromToday) ? {...earningsDateObject, daysFromToday: daysFromToday} : null;
}